<script>
  import { createEventDispatcher } from 'svelte';
  import {sgettext} from '../../i18n.js';

  export let id = 'stepperNavigator';
  export let currentStep = 1;
  export let finalStep = 3;
  export let enableSaveAndAddAnother = false;
  export let sending = false;
  export let disabled = false;
  export let next = () => console.log('validate');
  export let back = () => {};
  export let enableCancel = false;
  export let cancel = () => {};

  export let addAnother = false;
  function saveAndAddAnother(e) {
    addAnother = true;
    next(e);
  }

  const dispatch = createEventDispatcher();


  function handleBack() {
    currentStep = currentStep - 1;
    if (currentStep < 1) {
      currentStep = 1;
    }
    back();
  }

</script>

<div {id} class="stepper-navigator">
  <div class="left">
    {#if currentStep > 1}
      <button class="btn btn-secondary" on:click={handleBack}
        >{sgettext('$$BACK$$')}</button
      >
    {:else if enableCancel}
      <button class="btn btn-outline" on:click={cancel}
        >{sgettext('$$CANCEL$$')}</button
      >
    {/if}
  </div>
  <div class="right">
    {#if enableSaveAndAddAnother && currentStep === finalStep}
      <button
        class="btn btn-outline"
        on:click={saveAndAddAnother}
        disabled={sending || disabled}
      >
        {sgettext('$$SAVE_ADD_ANOTHER_2$$')}
      </button>
    {/if}
    <button
      class="btn btn-primary"
      on:click={next}
      disabled={sending || disabled}
    >
      {#if currentStep === finalStep}
        {#if sending}
          <i class="fa fa-spin fa-spinner" /> {sgettext('$$SAVING_1$$')}
        {:else}
          {sgettext('$$FINISH$$')}
        {/if}
      {:else}
        {sgettext('$$NEXT$$')}
      {/if}
    </button>
  </div>
</div>

<style>
  .stepper-navigator {
    display: flex;
    justify-content: space-between;
  }

  .left button {
    margin-left: 0;
  }
</style>
